import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import VendordashboardLayout from "../vendor/comman/master";
import {
    Attandance,
    Dashboard,
    Events,
    EventsList,
    Profile,
    AddService,
    EditService,
    ServiceList,
    AddStaff,
    EditStaffs,
    StaffLists,
    Location,
    AddLocation,
    EditLocation,
    EditSubscription,
    AddDemo
    
} from "../vendor"
import VendorBookings from "../vendor/pages/Bookings/VendorBookings";
import ViewBookingDetails from "../vendor/pages/Bookings/ViewBookingDetails";
import Members from "../vendor/pages/Members/Members";
import MemberList from "../vendor/pages/Members/MemberList";
import EditMembers from "../vendor/pages/Members/EditMember";
import AddSubscription from "../vendor/pages/Service/AddSubscription";
import EventsView from "../vendor/pages/Events/EventsView";
import AdminEventPage from "../vendor/pages/Events/Events";
import Attendance from "../vendor/pages/Attandance/Attandance";
import DemoList from "../vendor/pages/Demo/DemoList";
import EditDemo from "../vendor/pages/Demo/EditDemo";

function VendorRoutes(){
    return(
    <>
<BrowserRouter>
<Routes>
    <Route path="/" element={<VendordashboardLayout/>}>
    <Route path="/" element={<Profile/>}/>
    <Route path="/dashboard" element={<Dashboard/>}/>
    <Route path="/View_Booking_Details/:id" element={<ViewBookingDetails/>}/>
    <Route path="/Member_List" element={<MemberList/>}/>
    <Route path="/Members" element={<Members/>}/>
    <Route path="/EditMembers/:id" element={<EditMembers/>}/>
    <Route path="/AddSubscription/" element={<AddSubscription/>}/>
    <Route path="/Edit&View_Events/:id" element={<EventsView/>}/>
    <Route path="/Add_Events" element={<AdminEventPage/>}/>
    <Route path="/Vendor_Bokkings" element={<VendorBookings/>}/>
    <Route path="/Add-Location" element={<AddLocation/>}/>

    <Route path="/locationlist" element={<Location/>}/>
    <Route path="/edit-location/:id" element={<EditLocation/>}/>
        <Route path="/attandance" element={<Attendance/>}/>
        <Route path="/servicelist" element={<ServiceList/>}/>
        <Route path="/addservice" element={<AddService/>}/>
        <Route path="/Editservice/:id" element={<EditService/>}/>
        <Route path="/edit-subscription/:id" element={<EditSubscription/>}/>
        <Route path="/stafflist" element={<StaffLists/>}/>
        <Route path="/addstaff" element={<AddStaff/>}/>
        <Route path="/edit-staff/:id" element={<EditStaffs/>}/>
        <Route path="/events-list" element={<EventsList/>}/>

        <Route path="/add-demo" element={<AddDemo/>}/>
        <Route path="/demo_list" element={<DemoList/>}/>
     <Route path="/Edit-demo/:id" element={<EditDemo/>}/>










</Route>
</Routes>


</BrowserRouter>

    </>
    )

}
export default VendorRoutes;



